import { render, staticRenderFns } from "./uploadsolution.html?vue&type=template&id=f304b2d0&"
import script from "./uploadsolution.js?vue&type=script&lang=js&"
export * from "./uploadsolution.js?vue&type=script&lang=js&"
import style0 from "./uploadsolution.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports